import { GridItem, SearchState } from '../../../models';
import { RootStoreState } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';
import { BannersReducer } from './grid-items-reducers/banners.reducer';
import { GridItemsReducer } from './grid-items-reducers/grid-items-reducer.interfaces';
import { NextQueriesReducer } from './grid-items-reducers/next-queries.reducer';
import { PromotedsReducer } from './grid-items-reducers/promoteds.reducer';
import { ResultsReducer } from './grid-items-reducers/results.reducer';

export class GridItemsGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.gridItems]: (state: SearchState, getters: any, rootState: RootStoreState, rootGetters: any): GridItem[] =>
      this.gridItemsReducers.reduce((gridItems: GridItem[], reducer: GridItemsReducer) =>
        reducer.reduce(gridItems, { state, getters, rootState, rootGetters }), [])
  };

  private gridItemsReducers: GridItemsReducer[] = [
    new PromotedsReducer(),
    new ResultsReducer(),
    new BannersReducer(),
    new NextQueriesReducer()
  ];  // TODO This should be injected in the second refactor of the store. We need to be careful of the order of them
}
